import _ from 'lodash';
import React, { useEffect, useRef, useState } from 'react';
import { ActionMenu } from '../../../../action-menu';
import { Button } from '../../../../button';
import { IconID } from '../../../../icon';
import { Popover } from '../../../../popover';
import styles from './menu-cell.module.scss';
export const MenuCell = ({ context, data, }) => {
    var _a;
    const { rowMenu } = context;
    const [isPopoverOpen, setIsPopoverOpen] = useState(false);
    const popoverRef = useRef(null);
    const popperRef = useRef(null);
    const buttonRef = useRef(null);
    const rowMenuConfig = _.isFunction(rowMenu) ? rowMenu(data) : rowMenu;
    const closeOnEscape = (_a = rowMenuConfig === null || rowMenuConfig === void 0 ? void 0 : rowMenuConfig.closeOnEscape) !== null && _a !== void 0 ? _a : false;
    const getMappedMenuItemGroups = () => {
        if (!rowMenu || !rowMenuConfig || !rowMenuConfig.items) {
            return [];
        }
        const items = rowMenuConfig.items.map(({ id, label, icon, onClick, disabled }) => ({
            id,
            label,
            icon,
            onClick: (event) => {
                setIsPopoverOpen(false);
                onClick(event, data);
            },
            disabled,
        }));
        return [
            {
                title: rowMenuConfig.title,
                items,
            },
        ];
    };
    useEffect(() => {
        const handleDocumentKeyPress = (event) => {
            var _a;
            if (!isPopoverOpen)
                return;
            // Handle Escape key
            if (event.key === 'Escape' && closeOnEscape) {
                setIsPopoverOpen(false);
                (_a = buttonRef.current) === null || _a === void 0 ? void 0 : _a.focus();
                return;
            }
            // Handle keyboard navigation (Tab, etc.) - same logic as popover-toggle
            // Check where current focus is after key press
            setTimeout(() => {
                var _a, _b;
                if (document.activeElement &&
                    !((_a = popoverRef.current) === null || _a === void 0 ? void 0 : _a.contains(document.activeElement)) &&
                    !((_b = popperRef.current) === null || _b === void 0 ? void 0 : _b.contains(document.activeElement))) {
                    setIsPopoverOpen(false);
                }
            }, 0);
        };
        // Handle keyboard navigation and escape key
        document.addEventListener('keydown', handleDocumentKeyPress);
        return () => {
            document.removeEventListener('keydown', handleDocumentKeyPress);
        };
    }, [isPopoverOpen, closeOnEscape]);
    const menuItemGroups = getMappedMenuItemGroups();
    if (!menuItemGroups || !menuItemGroups.length) {
        return null;
    }
    return (React.createElement("div", { className: styles.menuCellContainer },
        React.createElement("div", { className: styles.openMenuButton, ref: popoverRef },
            React.createElement(Button, { onClick: () => {
                    setIsPopoverOpen(!isPopoverOpen);
                }, icon: IconID.MORE, type: "secondary", size: "m", ariaLabel: rowMenuConfig.title, "data-tooltip-content": rowMenuConfig.title, buttonRef: buttonRef })),
        React.createElement(Popover, { align: "bottom-end", content: React.createElement(ActionMenu, { show: isPopoverOpen, menuItemGroups: menuItemGroups }), targetRef: popoverRef, popperRef: popperRef, isVisible: isPopoverOpen, onClickOutside: () => setIsPopoverOpen(false) })));
};
//# sourceMappingURL=menu-cell.js.map